import { Navigate, useLocation } from "react-router-dom";

export default function LandingPage({ loggedIn }: { loggedIn: boolean }) {
  const location = useLocation();

  if (!loggedIn) {
    const redirectLink = `/sign-up${location.search}`;

    return <Navigate to={redirectLink} />;
  }

  return <Navigate to={`/dashboard/home${location.search}`} replace />;
}
